export type TennMobClientType = '10nMobile' | '10nMobileLocal';

export type TennWebClientType = '10nWeb' | '10nWebLocal';

export type HammerWebClientType = 'HammerWeb' | 'HammerWebLocal';

export type MyPortalTradeClientType = 'MyPortalTrade' | 'MyPortalTradeLocal';

export type TennWealthWebClientType = '10nWealthWeb' | '10nWealthWebLocal';

// TODO: Fetch those from BE in ART-4352
export enum PortalType {
  FundPortal = 'AlaricFundPortal',
  MyPortalTrade = 'AlaricMyPortalTrade',
}
